import React from "react";
import { Grid } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";

import TopNav from "../../common/containers/top-nav";
import { isFeatureActive } from "../../company/feature/helpers";
import { ReportsFeatureDetails } from "../../company/feature/helpers";
import CompanyFeatureComponentItemLarge from "../../company/feature/item-large.component";
import { showCompanyFeatureToggleConfirmation } from "../../company/feature/actions";
import CompanyFeatureContainerConfirmToggle from "../../company/feature/confirm-toggle.container";
import ReportsContainer from "../container/reports";

const ReportsPageHome = () => {
    const { company } = useSelector(({ auth }) => ({
        company: auth.user.company,
    }));

    const hasReportsFeature = isFeatureActive(company, ReportsFeatureDetails);
    const dispatch = useDispatch();
    const handleActivateFeature = feature => {
        dispatch(showCompanyFeatureToggleConfirmation(feature));
    };

    return (
        <Grid>
            <TopNav
                headerIcon="chart line"
                headerContent="Reports"
                subheader="Insightful analysis of your invoicing data"
            />

            <Grid.Column mobile={16} computer={16}>
                {hasReportsFeature ? (
                    <ReportsContainer />
                ) : (
                    <>
                        <CompanyFeatureContainerConfirmToggle />
                        <CompanyFeatureComponentItemLarge
                            toggleActivation={handleActivateFeature}
                            feature={ReportsFeatureDetails}
                            isActive={false}
                        />
                    </>
                )}
            </Grid.Column>
        </Grid>
    );
};

export default ReportsPageHome;
